import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: '',
        authentication:0,
        enterprise:0, //企业认证信息
        comid:'',
    },
    mutations: {
        set_token(state, token){
            state.token = token;
            sessionStorage.token = token
        },
        //个人认证状态
        set_authentication(state,payload){
            state.authentication=payload
        },
        //企业认证状态
        set_enterprise(state,payload){
            state.enterprise=payload
        },
        set_comid(state,payload){
            state.comid=payload
        }

    },
    actions: {
    },
    modules: {
    },
    plugins: [createPersistedState({
        storage: window.sessionStorage
    })]
})
